module.exports = __webpack_public_path__ + "static/img/share01.eee8990.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share01.png
// module id = jvko
// module chunks = 1